import React, { useContext } from "react";
import { ReferencePickerProvider } from "@adsk/acc-reference-picker";
import { useReferencePickerPlugins } from "./useReferencePickerPlugins";
import {
  ISSUES_DOMAIN,
  ISSUES_ENTITY_TYPE,
} from "../../constants/relationships";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { getOrderedIssues } from "@adsk/acc-issues-core/state/redux/ducks/issuesCollection";
import { Issue } from "@adsk/acc-issues-types";
import { issuesTabReferenceProviderContext } from "./issuesTabReferenceProviderContext";
import { RemoteProvider } from "@adsk/exo-skeleton-react";

export const ReferencesDataProvider = ({
  children,
  withIssueIds = false,
}: {
  children?: React.ReactNode;
  withIssueIds?: boolean;
}) => {
  const referencePickerPlugins = useReferencePickerPlugins();

  const issues = useSelector(getOrderedIssues) as Issue[];
  const isInContext = useContext(issuesTabReferenceProviderContext);

  return isInContext ? (
    <>{children}</>
  ) : (
    <ReferencePickerProvider
      sourceEntityDomain={ISSUES_DOMAIN}
      sourceEntityType={ISSUES_ENTITY_TYPE}
      plugins={referencePickerPlugins}
      sourceEntityIds={withIssueIds ? issues.map(issue => issue.id) : undefined}
    >
      <RemoteProvider scope="accIssues" moduleName="./App">
        <issuesTabReferenceProviderContext.Provider value={true}>
          {children}
        </issuesTabReferenceProviderContext.Provider>
      </RemoteProvider>
    </ReferencePickerProvider>
  );
};
